<template>
    <div class="directoperation-search">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Registro"
                    sub="Pesquisa de Lançamento Direto"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    title="Adicionar Registro"
                    @click="actionNewDirectOperation"
                    variant="dark"
                    class="mr-2 mt-2 fa fa-plus"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 fa"
                    :class="icon"
                    @click=";[loadDirectOperations(), (showTable = !showTable)]"
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Início:"
                    label-for="directoperation-search-start_date"
                >
                    <b-form-input
                        id="directoperation-search-start_date"
                        type="date"
                        v-model="start_date"
                        ref="inputsearch"
                        @input="loadDirectOperations"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Término:"
                    label-for="directoperation-search-end_date"
                >
                    <b-form-input
                        id="directoperation-search-end_date"
                        type="date"
                        v-model="end_date"
                        @input="loadDirectOperations"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="3" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="directoperation-search-company_id"
                >
                    <b-form-select
                        id="directoperation-search-company_id"
                        @input="loadDirectOperations"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Status:"
                    label-for="directoperation-search-document_status_id"
                >
                    <b-form-select
                        id="directoperation-search-document_status_id"
                        size="sm"
                        @input="loadDirectOperations"
                        :options="documentstatus"
                        v-model="document_status_id"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" sm="12">
                <template>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <transition name="slide" type="animation" appear>
                        <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            v-show="showTable"
                            hover
                            key="slide"
                            head-variant="light"
                            :items="directoperations"
                            :fields="fieldsDirectOperation"
                        >
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Editar registro"
                                    size="sm"
                                    variant="light"
                                    @click="
                                        actionEditDirectOperation(data.item)
                                    "
                                    class="mr-2 mt-2 fa fa-pencil"
                                >
                                </b-button>
                                <b-button
                                    title="Excluir registro"
                                    size="sm"
                                    variant="light"
                                    v-if="data.item.document_status_id === 1"
                                    @click=";[showMsgBoxDeleted(data.item)]"
                                    class="mr-2 mt-2 fa fa-trash"
                                >
                                </b-button>
                                <b-button
                                    title="Cancelar registro"
                                    size="sm"
                                    variant="light"
                                    v-if="
                                        data.item.document_status_id !== 1 &&
                                            data.item.document_status_id !== 5
                                    "
                                    @click="showMsgBoxCancel(data.item)"
                                    class="mr-2 mt-2 fa fa-ban"
                                >
                                </b-button>
                                <b-button
                                    title="Recontabilização"
                                    size="sm"
                                    variant="light"
                                    v-if="data.item.document_status_id === 2"
                                    @click=";[showMsgBoxAccounting(data.item)]"
                                    class="mr-2 mt-2 fa fa-exchange"
                                >
                                </b-button>
                                <b-button
                                    title="Acesso a Contabilização"
                                    size="sm"
                                    variant="light"
                                    v-b-modal.modalAccounting
                                    v-show="
                                        data.item.accounting_direct_operation
                                    "
                                    @click="
                                        AccountingDirectOperation(data.item)
                                    "
                                    class="mr-2 mt-2 fa fa-puzzle-piece"
                                >
                                </b-button>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
        </b-row>
        <b-modal
            id="modalAccounting"
            ref="modal"
            hide-footer
            size="xl"
            title-tag="h6"
            title="Contabilização"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-table
                    class="table-responsive"
                    head-variant="dark"
                    hover
                    striped
                    :items="accountingentrys"
                    :fields="fieldsAccounting"
                >
                </b-table>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError, searchglobalkey } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
var moment = require('moment-timezone')

export default {
    name: 'DirectOperationSearch',
    components: { PageTitle },
    data: function() {
        return {
            mode: 'insert',
            modeDirectOperation: 'insert',
            start_date: null,
            end_date: null,
            document_status_id: null,
            company_id: null,
            search: '',
            searchEntity: '',
            boxCancel: '',
            directoperation: {},
            directoperations: [],
            documentstatus: [],
            entity: {},
            entitys: [],
            entitysshearch: [],
            companys: [],
            accountingentrys: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            showDirectOperation: false,
            showEntity: false,
            perPage: 5,
            currentPage: 1,
            fieldsDirectOperation: [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'name_operation', label: 'Operação', sortable: true },
                {
                    key: 'direct_release_date',
                    label: 'Data Lançamento',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                {
                    key: 'diretc_release_value',
                    label: 'Valor',
                    sortable: false
                },
                {
                    key: 'name_document_status',
                    label: 'Status',
                    sortable: false
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsEntity: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsAccounting: [
                {
                    key: 'accounting_date',
                    label: 'Contabilizado',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'name_cost_center',
                    label: 'Centro de Custo/Receita',
                    sortable: false
                },
                {
                    key: 'account_plan',
                    label: 'Conta',
                    sortable: false,
                    variant: 'light'
                },
                {
                    key: 'account_name_plan',
                    label: 'Descrição',
                    sortable: false,
                    variant: 'secondary'
                },
                {
                    key: 'accounting_nature_account',
                    label: 'Nat.',
                    sortable: false,
                    variant: 'light'
                },
                {
                    key: 'accounting_value',
                    label: 'Valor',
                    sortable: false,
                    variant: 'secondary'
                },
                {
                    key: 'accounting_comments',
                    label: 'Histórico',
                    sortable: false
                }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        searchglobal() {
            return this.$store.state.searchglobal
        },
        filteredListEntity() {
            return this.entitysshearch.filter(entity => {
                return entity.name_entity
                    .toLowerCase()
                    .includes(this.searchEntity.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.directoperations.length
        }
    },
    methods: {
        showMsgBoxDeleted(directoperation) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Excluir o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeDirectOperation(directoperation)
                    }
                })
        },
        showMsgBoxCancel(directoperation) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Cancelar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.canceledDirectOperation(directoperation)
                    }
                })
        },
        showMsgBoxAllow(directoperation) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Autorizar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        this.allowDirectOperation(directoperation)
                    }
                })
        },
        showMsgBoxAccounting(directoperation) {
            this.boxAccount = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Recontabilizar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-1',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxAccount = value
                    if (this.boxAccount === true) {
                        await this.reaccountingDirectOperation(directoperation)
                    }
                })
        },
        formatDate(date) {
            return moment
                .utc(date)
                .local()
                .format('YYYY-MM-DD')
        },
        loadEntitys() {
            const url = `${baseApiUrl}/entitys`
            axios.get(url).then(res => {
                this.entitysshearch = res.data
            })
        },
        loadDirectOperations() {
            const url = `${baseApiUrl}/directoperationssearchdate/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&status_id=${this.directoperation_document_status_id}`
            axios.get(url).then(res => {
                this.directoperations = res.data
            })
        },
        async canceledDirectOperation(directoperation) {
            this.directoperation = { ...directoperation }

            if (this.directoperation.id) {
                this.directoperation.user_canceled_id = this.user.id
                this.directoperation.canceled_date = this.formatDate(
                    moment.utc().local()
                )

                this.directoperation.document_status_id = 5

                const method = this.directoperation.id ? 'put' : 'post'
                const id = this.directoperation.id
                    ? `/${this.directoperation.id}`
                    : ''
                await axios[method](
                    `${baseApiUrl}/directoperations${id}`,
                    this.directoperation
                )
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.loadDirectOperations()
                    })
                    .catch(showError)
            }
        },
        async removeDirectOperation(directoperation) {
            const id = directoperation.id
            await axios
                .delete(`${baseApiUrl}/directoperations/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadDirectOperations()
                })
                .catch(showError)
        },
        async setEntity(entity) {
            if (!this.directoperation.directoperation_entity_id) {
                this.directoperation.directoperation_entity_id = entity.id
            }

            const url = `${baseApiUrl}/entitys/${this.directoperation.directoperation_entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        actionEditDirectOperation(directoperation) {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            if (directoperation.direct_release_date)
                directoperation.direct_release_date = this.formatDate(
                    directoperation.direct_release_date
                )
            if (directoperation.direct_settlement_date)
                directoperation.direct_settlement_date = this.formatDate(
                    directoperation.direct_settlement_date
                )

            this.$router.push({
                name: 'RecordDirectOperation',
                params: { id: directoperation.id },
                query: { directoperationbase: directoperation }
            })
        },
        async loadDocumentStaus() {
            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                this.documentstatus = res.data.map(documentstatu => {
                    return {
                        value: documentstatu.id,
                        text: documentstatu.name_document_status
                    }
                })
            })
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
            this.$refs.inputsearch.focus()
        },
        actionNewDirectOperation() {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            } else {
                const directoperation = {}
                directoperation.document_status_id = 1
                this.$router.push({
                    name: 'RecordDirectOperation',
                    query: { directoperationbase: directoperation }
                })
            }
        },
        async reaccountingDirectOperation(directoperation) {
            this.directoperation = { ...directoperation }

            if (this.compan.require_account_entry === 1) {
                if (this.directoperation.document_status_id === 2) {
                    await axios['post'](
                        `${baseApiUrl}/accountingdirectoperation`,
                        this.directoperation
                    )
                        .then(async () => {
                            await this.loadDirectOperations()
                            this.$toasted.global.defaultSuccess()
                        })
                        .catch(showError)
                }
            } else {
                this.$toasted.global.defaultWarning({
                    msg:
                        'Empresa não está configurada para usar a contabilização de lançamento.'
                })
            }
        },
        async AccountingDirectOperation(release) {
            const id = release.id
            await axios
                .get(`${baseApiUrl}/accountingentrydirectoperations/${id}`)
                .then(res => {
                    this.accountingentrys = res.data
                })
        }
    },
    mounted() {
        this.loadCompanys()
        this.loadDocumentStaus()
        this.showTable = true

        if (this.searchglobal) {
            this.start_date = moment(
                this.searchglobal.start_date_release
            ).format('YYYY-MM-DD')
            this.end_date = moment(this.searchglobal.end_date_release).format(
                'YYYY-MM-DD'
            )
            this.company_id = this.searchglobal.company_id_release
            this.operation_id = this.searchglobal.operation_release
        } else {
            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            } else {
                this.start_date = moment()
                    .startOf('month')
                    .format('YYYY-MM-DD')
                this.end_date = moment()
                    .endOf('month')
                    .format('YYYY-MM-DD')
                this.company_id = this.compan.id
                this.loadDirectOperations()
            }
        }
    }
}
</script>

<style>
.directoperation-search {
    font-size: 0.7rem;
}

.directoperation-search input,
label,
form {
    font-size: 0.7rem;
}
.directoperation-search button {
    font-size: 0.7rem;
}

.directoperation-search select {
    font-size: 0.7rem;
}

.directoperation-search table {
    font-size: 0.7rem;
}

#modalAccounting {
    font-size: 0.7rem;
}

#modalAccounting button {
    font-size: 0.7rem;
}
#modalAccounting input,
label,
form {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
